module.exports = __webpack_public_path__ + "static/media/BELGIUM.d8bddc15.svg";